import SmallCategoryCard from '@components/shared/SmallCategoryCard';
import { GridColumn, GridRow } from '@tkww/orion-web-ds-structure';
import { categoryMediaMappings } from '@utils/categoryMediaMappings';
import { H3 } from '@xo-union/tk-ui-typography';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import CategoriesConstants, {
	CATEGORY_FOOTER_EXPERIMENT_STATES,
	EXTRA_TOP_CATEGORIES,
} from '../../../constants/categories';
import Styles from './styles.scss';

export const FooterCategories = (props) => {
	const { city, footerCategories, stateCode } = props;

	let selectedCategories = [...footerCategories];
	if (CATEGORY_FOOTER_EXPERIMENT_STATES.includes(stateCode.toLowerCase())) {
		selectedCategories = [...selectedCategories, ...EXTRA_TOP_CATEGORIES];
	}

	return (
		<Fragment>
			<GridRow>
				<GridColumn xs="12">
					<H3 className={Styles.heading}>Wedding Vendors in {city}</H3>
				</GridColumn>
			</GridRow>
			<GridRow vGutters className={Styles.footerCategoriesGrid}>
				{selectedCategories.map((category) => (
					<div key={category.id} className={Styles.categoryGridColumn}>
						<SmallCategoryCard
							categoryCode={category.code}
							categoryName={category.name}
							categorySlug={category.urlSlug}
							city={city}
							key={category.code}
							mediaApiId={categoryMediaMappings[category.code].mediaId}
							stateCode={stateCode}
						/>
					</div>
				))}
			</GridRow>
		</Fragment>
	);
};

FooterCategories.propTypes = {
	city: PropTypes.string.isRequired,
	footerCategories: PropTypes.arrayOf(
		PropTypes.shape({
			code: PropTypes.string.isRequired,
			name: PropTypes.string.isRequired,
			urlSlug: PropTypes.string.isRequired,
		}),
	),
	stateCode: PropTypes.string.isRequired,
};

// default "top 10" categories to display
FooterCategories.defaultProps = {
	footerCategories: CategoriesConstants.TOP_TEN_CATEGORIES,
};
